import { render } from "./index.vue?vue&type=template&id=443d2bbe&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=443d2bbe&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443d2bbe"]])

export default __exports__